import {
  initialState,
  Actions,
  State,
  GET_EXPERT_GROUPS,
  GET_EXPERT_GROUPS_SUCCESS,
  GET_EXPERT_GROUPS_ERROR,
} from "../../types/expert/get-expert-groups";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_EXPERT_GROUPS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_EXPERT_GROUPS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_EXPERT_GROUPS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
